import { type schemaType } from '~~/shared/api/rurality/v3/search/cottage-gallery/schema'
import { type paramsType } from '~~/shared/api/rurality/v3/search/cottage-gallery/paramsSchema'
import {
  serverFetchWrapperMeta,
  browserFetchWrapperMeta,
} from '~~/server/utils/rurality/v3/endpointWrapper'

const endpoint = '/search/cottage-gallery'

type returnType = ResponseRuralityMetaType<schemaType>

export const serverFetch = (params: paramsType): Promise<returnType> =>
  serverFetchWrapperMeta<paramsType, schemaType>(endpoint, params)

export const browserFetch = (params: paramsType): Promise<returnType> =>
  browserFetchWrapperMeta<paramsType, schemaType>(endpoint, params)
